/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface SupportRequestDto
 */
export interface SupportRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SupportRequestDto
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportRequestDto
     */
    csoErrorResponse?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SupportRequestDto
     */
    $type?: SupportRequestDtoTypeEnum;
}


/**
 * @export
 */
export const SupportRequestDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoSupportRequestDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.SupportRequestDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SupportRequestDtoTypeEnum = typeof SupportRequestDtoTypeEnum[keyof typeof SupportRequestDtoTypeEnum];



/**
 * Check if a given object implements the SupportRequestDto interface.
 */
export function instanceOfSupportRequestDto(value?: unknown): value is SupportRequestDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SupportRequestDtoTypeEnum)[0];
}

export function SupportRequestDtoFromJSON(json: any): SupportRequestDto {
    return SupportRequestDtoFromJSONTyped(json, false);
}

export function SupportRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'csoErrorResponse': json['csoErrorResponse'] == null ? undefined : json['csoErrorResponse'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function SupportRequestDtoToJSON(value?: SupportRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'message': value['message'],
        'csoErrorResponse': value['csoErrorResponse'],
        '$type': value['$type'],
    });
}

